import clientHttp, { prefixBase } from '../../clientHttp';
import ResourceHttp from '../../resourceHttp';

class MarcaResourceHttp extends ResourceHttp {
  constructor(http, resource) {
    super();
    this.http = http;
    this.resource = resource;
  }

  uploadFile(motorista, parans) {
    return this.http.post(`${this.resource}/${motorista}/upload`, parans);
  }

  destroyFile(motoristaId, documentoId) {
    return this.http.delete(`${this.resource}/${motoristaId}/${documentoId}/destroy_file`);
  }

  filter(params) {
    return this.http.get(this.resource, { params });
  }
}

const resource = 'motorista';

const moduleHttp = new MarcaResourceHttp(clientHttp, prefixBase + resource);

export default moduleHttp;
